// Module
var code = "<wt-group-script-state class=\"flex-directive\" form-controller=\"vm.codeFormController\" group=\"vm.selectedGroup\" is-code-editor-disabled=\"vm.isCodeEditorDisabled\"> </wt-group-script-state>";
// Exports
module.exports = code;